import { Appointment } from 'src/gql/graphql';
import { useGQLMutation } from 'src/ui/utils/graphql';
import { Modal, ModalBase } from 'src/ui/components/Modal/Modal';
import { Heading } from 'src/ui/components/Heading/Heading';
import { Button } from 'src/ui/components/Button';
import { COMPLETE_APPOINTMENT } from 'src/graphql/Appointments';
import { useForm } from 'react-hook-form';
import styles from './CompleteAppointmentModal.module.scss';
import { TextArea } from '../../../../../../ui/components/TextArea/TextArea';

interface CompleteAppointmentModalI extends ModalBase {
  appointment: Appointment;
}

export const CompleteAppointmentModal = ({
  appointment,
  isOpen,
  setIsOpen,
}: CompleteAppointmentModalI) => {
  const { register, handleSubmit } = useForm<{ finalComment: string }>();
  const { mutation: completeAppointmentMutation } = useGQLMutation<
    Appointment,
    { appointmentId: string; companyId: string; finalComment: string }
  >(COMPLETE_APPOINTMENT, {
    onCompleted: (data) => {
      console.log('Appointment completed:', data);
      setIsOpen(false); // Close the modal after completing the appointment
    },
  });

  const handleCompleteAppointment = (data: { finalComment: string }) => {
    completeAppointmentMutation({
      variables: {
        appointmentId: appointment.id,
        companyId: appointment.Company.id,
        finalComment: data.finalComment || '',
      },
    });
  };

  return (
    <Modal
      className={styles.root}
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
    >
      <Heading className={styles.heading} headingLevel="h2">
        ¿Está seguro de que desea completar la cita?
      </Heading>
      <div>
        <TextArea
          register={register('finalComment')}
          name="finalComment"
          classname={styles.textArea}
          placeholder="Ingresa tu comentario de finalización de cita (opcional)..."
        />
      </div>
      <div className={styles.actions}>
        <Button onClick={() => setIsOpen(false)}>Cancelar</Button>
        <Button
          btnStyle="secondary"
          onClick={handleSubmit(handleCompleteAppointment)}
        >
          Confirmar
        </Button>
      </div>
    </Modal>
  );
};
